export default "__VITE_ASSET__e5a2ddf8__$_?component__"